import type { ModalProps } from 'antd';
import { Modal } from 'antd';

import { Button } from '@shared/components/Button';

interface Props extends ModalProps {
  onOk: () => void;
}
const InvalidTypeModal = ({ onOk, ...rest }: Props) => (
  <Modal centered closable={false} footer={null} {...rest}>
    <div className="mx-auto flex w-3/4 flex-col items-center justify-center text-center text-base">
      <b className="text-base">Error in uploading</b>
      <br />
      Only files with the following extensions are allowed: jpg jpeg png.
      <br />
      (Code: ICON0038)
      <Button className="json-checked mt-6 w-full" onClick={onOk}>
        OK
      </Button>
    </div>
  </Modal>
);

export default InvalidTypeModal;
